/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AwsEc2InstanceRestoreResult {
  /**
  * ID of the restored EC2 instance.
  */
  'instanceId': string;
  'volumeId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instanceId",
      "baseName": "instanceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeId",
      "baseName": "volumeId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEc2InstanceRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

